var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 9.91671C9.28244 9.91671 9.91671 9.28244 9.91671 8.50004C9.91671 7.71764 9.28244 7.08337 8.50004 7.08337C7.71764 7.08337 7.08337 7.71764 7.08337 8.50004C7.08337 9.28244 7.71764 9.91671 8.50004 9.91671Z",
    fill: "#BCC2C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 4.95833C9.28244 4.95833 9.91671 4.32407 9.91671 3.54167C9.91671 2.75926 9.28244 2.125 8.50004 2.125C7.71764 2.125 7.08337 2.75926 7.08337 3.54167C7.08337 4.32407 7.71764 4.95833 8.50004 4.95833Z",
    fill: "#BCC2C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 14.875C9.28244 14.875 9.91671 14.2407 9.91671 13.4583C9.91671 12.6759 9.28244 12.0416 8.50004 12.0416C7.71764 12.0416 7.08337 12.6759 7.08337 13.4583C7.08337 14.2407 7.71764 14.875 8.50004 14.875Z",
    fill: "#BCC2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.76e1659209765d228fdd2ef8037977dc.svg";
export { ForwardRef as ReactComponent };